import { el, clear } from '../../utils/dom.js';
import { Loans, Responsibles } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { LineEditor } from '../../components/line-editor.js';
import { ok, err } from '../../components/toast.js';
import { navigate } from '../../router/index.js';

export default async function LoansFormPage(outlet) {
  clear(outlet);
  let resp = [];
  try { resp = (await Responsibles.list({ limit: 200 })).data || []; }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Nuevo prestamo'),
    el('a', { href: '#/loans', class: 'btn ghost' }, '← Volver'),
  ));

  const lineEditor = LineEditor({ withPrice: false, onlyAvailable: true });

  const now = new Date();
  const tomorrow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const data = readForm(form);
      const items = lineEditor.getLines();
      const v = lineEditor.validate();
      if (v) { err(v); return; }
      try {
        const created = await Loans.create({
          responsible_id: data.responsible_id,
          start_date: new Date(data.start_date).toISOString(),
          expected_return_date: new Date(data.expected_return_date).toISOString(),
          notes: data.notes || undefined,
          items,
        });
        ok(`Prestamo ${created.code} creado`);
        navigate(`/loans/${created.id}`);
      } catch (ex) { err(ex.message); }
    },
  });

  const card = el('div', { class: 'card mb-4' });
  const grid = el('div', { class: 'form-grid' });
  grid.append(
    field({ name: 'responsible_id', label: 'Responsable interno', type: 'select', required: true, options: resp.map((r) => ({ value: r.id, label: `${r.full_name}${r.position ? ' — ' + r.position : ''}` })) }),
    field({ name: 'start_date', label: 'Fecha de salida', type: 'datetime-local', required: true, value: toLocalInput(now) }),
    field({ name: 'expected_return_date', label: 'Fecha esperada de devolucion', type: 'datetime-local', required: true, value: toLocalInput(tomorrow) }),
    field({ name: 'notes', label: 'Notas', type: 'textarea', full: true }),
  );
  card.appendChild(grid);
  form.appendChild(card);

  form.appendChild(lineEditor.root);

  form.appendChild(el('div', { class: 'flex gap-2 justify-between' },
    el('a', { href: '#/loans', class: 'btn' }, 'Cancelar'),
    el('button', { class: 'btn primary', type: 'submit' }, 'Crear prestamo'),
  ));
  outlet.appendChild(form);
}

function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
